module.exports = __webpack_public_path__ + "static/media/DSC09145_20180710_027-1.e02211a8.jpg";